// GAVION X1: objectifs quotidiens et classement.
export const goalsFr = {
  metrics: {
    dials: "Appels",
    inbound: "Entrants",
    conversations: "Conversations",
    demos: "Démos bookées",
    deals_won: "Deals gagnés",
  },
  my_day: {
    title: "Ma journée",
    subtitle: "Vos objectifs d'aujourd'hui",
    progress: "%{count} sur %{target}",
    progress_aria: "%{label} : %{count} sur %{target}",
    remaining: "Encore %{smart_count} |||| Encore %{smart_count}",
    hit: "Objectif atteint",
    all_hit: "Bravo ! Tous vos objectifs du jour sont atteints.",
    no_goals: "Aucun objectif quotidien n'est défini.",
    error: "Impossible de charger vos objectifs.",
  },
  leaderboard: {
    title: "Classement",
    description:
      "Appels, conversations, démos et deals gagnés par représentant (aujourd'hui, semaine, mois).",
    period_label: "Période du classement",
    periods: {
      today: "Aujourd'hui",
      week: "Cette semaine",
      month: "Ce mois-ci",
    },
    rank: "Rang",
    rep: "Représentant",
    you: "vous",
    leader: "En tête",
    empty: "Aucun représentant actif.",
    error: "Impossible de charger le classement.",
    see_all: "Voir le classement",
  },
  settings: {
    title: "Objectifs",
    intro:
      "Cibles quotidiennes affichées dans « Ma journée ». Une cible à 0 désactive l'objectif.",
    defaults: "Objectifs quotidiens par défaut",
    per_rep: "Objectifs par représentant",
    per_rep_hint: "Laissez vide pour utiliser l'objectif par défaut.",
    rep: "Représentant",
    no_reps: "Aucun représentant actif.",
    save: "Enregistrer",
    saved: "Objectifs enregistrés",
    errors: {
      out_of_range: "Entrez un nombre entier entre 0 et 1000.",
    },
  },
};
